import { A11yModule } from '@angular/cdk/a11y';
import { ObserversModule } from '@angular/cdk/observers';
import { PortalModule } from '@angular/cdk/portal';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule, MatRippleModule } from '@angular/material/core';
import { MatTabLabelDirective } from '@shared/material/tabs/tab-label.directive';
import { MatTabGroupComponent } from './tab-group';
import { MatTabBodyComponent, MatTabBodyPortalDirective } from './tab-body';
import { MatTabNavComponent, MatTabLinkDirective } from './tab-nav-bar';
import { MatTabComponent } from './tab';
import { MatInkBarDirective } from './ink-bar.directive';
import { MatTabHeaderComponent } from './tab-header';
import { MatTabLabelWrapperDirective } from './tab-label-wrapper.directive';

@NgModule({
  imports: [CommonModule, MatCommonModule, PortalModule, MatRippleModule, ObserversModule, A11yModule, CdkScrollable],
  // Don't export all components because some are only to be used internally.
  exports: [
    MatCommonModule,
    MatTabGroupComponent,
    MatTabComponent,
    MatTabNavComponent,
    MatTabLinkDirective,
    MatTabLabelDirective,
  ],
  declarations: [
    MatTabGroupComponent,
    MatTabBodyPortalDirective,
    MatTabComponent,
    MatInkBarDirective,
    MatTabLabelWrapperDirective,
    MatTabNavComponent,
    MatTabLinkDirective,
    MatTabBodyComponent,
    MatTabHeaderComponent,
    MatTabLabelDirective,
  ],
})
export class TabsModule {}
